import React, { useEffect, useState } from 'react';
import './AparatoPuntaje.css';
import { socket } from '../socket';

const AgregarPuntaje = ({scoreType, numberJudges}) => {
    const [nombre, setNombre] = useState('');
    const [nombres, setNombres] = useState([]);
    const [puntajes, setPuntajes] = useState([]);
    const [aparato, setAparato] = useState('');
    const [club, setClub] = useState('');
    const [nivel, setNivel] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [dificultad, setDificultad] = useState('');

    const [niveles, setNiveles] = useState([]);
    const [clubs, setClubs] = useState([]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        let ejecucionSum = 0;

        puntajes.map(puntaje => {
            ejecucionSum += parseFloat(puntaje);
        })

        const avgEjecucion = (ejecucionSum/numberJudges).toFixed(3);

        const dificultadNum = dificultad !== '' ? parseFloat(parseFloat(dificultad).toFixed(3)) : 0;


        const finalScore = scoreType === 'FIG' ? parseFloat(avgEjecucion) + dificultadNum : parseFloat(avgEjecucion);

        setDificultad(dificultadNum);

        if (!isNaN(avgEjecucion) && avgEjecucion >= 0.0 && avgEjecucion <= 10.00 && nombre && club && nivel && aparato && scoreType) {
            const data = {
                nombre: nombre,
                club: club,
                nivel: nivel,
                aparato: aparato,
                dificultad: dificultadNum,
                ejecucion: parseFloat(avgEjecucion),
                puntajeFinal: parseFloat(finalScore.toFixed(3)),
                scoreType: scoreType,
                puntajes: puntajes
            };
            if (aparato === 'Piso') {
                socket.emit('piso-puntaje', data);
            } else if (aparato === 'Viga') {
                socket.emit('viga-puntaje', data);
            } else if (aparato === 'Barra') {
                socket.emit('barra-puntaje', data);
            } else if (aparato === 'Salto') {
                socket.emit('salto-puntaje', data);
            }
            

            // CALL API TO ADD SCORE TO THE EXCEL
            try {
                const response = await fetch("https://infinitygymnastics-app-d76b087a1ffe.herokuapp.com/insertResult", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(data),
                });

                const result = await response.json();

                if (response.ok) {
                    console.log('Score inserted successfully:', result);

                    setSuccess(
                        `Puntaje enviado: ${finalScore.toFixed(3)}`
                    );
                    setError('');
                    setNombre('');
                    setDificultad('');
                    setPuntajes([]);
                } else {
                    console.error('Error inserting score:', result.error);
                    setSuccess('');
                    setError('Error enviando el puntaje');
                }
            } catch (error) {
                console.error("Failed to insert score:", error);
            }

        } else {
            setError('Error');
        }
    };

    const fetchNiveles = async () => {
        try {
            const response = await fetch(`https://infinitygymnastics-app-d76b087a1ffe.herokuapp.com/obtener_niveles`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                });
            if (!response.ok) {
                throw new Error(`Request failed with status: ${response.status}`);
            }
            const data = await response.json();
            console.log("fetchniveles", data.niveles);
            setNiveles(data.niveles);
        } catch (error) {
            console.error('Error obteniendo niveles', error);
        }
    };

    const fetchClubs = async () => {
        try {
            const response = await fetch(`https://infinitygymnastics-app-d76b087a1ffe.herokuapp.com/obtener_clubs`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                });
            if (!response.ok) {
                throw new Error(`Request failed with status: ${response.status}`);
            }
            const data = await response.json();
            console.log("fetchclubs", data.clubs);
            setClubs(data.clubs);
        } catch (error) {
            console.error('Error obteniendo niveles', error);
        }
    };

    const fetchNombres = async () => {
        try {
            const response = await fetch(`https://infinitygymnastics-app-d76b087a1ffe.herokuapp.com/obtener_nombres?club=${club}&nivel=${nivel}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                });

            if (!response.ok) {
                throw new Error(`Request failed with status: ${response.status}`);
            }
            const data = await response.json();
            const results = data.result;
            const nombres = results.map(item => `${item.nombre} ${item.apellido}`);
            setNombres(nombres);
        } catch (error) {
            console.error('Error obteniendo nombres', error);
        }
    };

    useEffect(() => {
        fetchNiveles();
        fetchClubs();
    }, []);

    useEffect(() => {
        if (club && nivel) {
            setNombres([]);
            fetchNombres();
        }
    }, [club, nivel]);

    return (
        <div className='columna-puntaje'>
            <h2 className='titulo'>Agregar Puntaje</h2>
            <form onSubmit={handleSubmit}>
            {/* aparato */}
            <div className='fila-puntaje'>
                <label for="nombre">
                    Aparato:
                </label>
                <select id="aparato" value={aparato} onChange={(e) => setAparato(e.target.value)}>
                    <option value="">--</option>
                    <option value="Salto">Salto</option>
                    <option value="Barra">Barra</option>
                    <option value="Viga">Viga</option>
                    <option value="Piso">Piso</option>
                </select>
            </div>
             {/* club */}
             <div className='fila-puntaje'>
                <label for="nombre">
                    Club:
                </label>
                <select id="club" value={club} onChange={(e) => setClub(e.target.value)}>
                    <option value="">--</option>
                    {clubs.map((club) => (
                        <option key={club} value={club}>
                            {club}
                        </option>
                    ))}
                </select>
            </div>
            {/* Nivel */}
            <div className='fila-puntaje' style={{marginBottom: '50px'}}>
                <label for="nombre">
                    Nivel:
                </label>
                <select id="nivel" value={nivel} onChange={(e) => setNivel(e.target.value)}>
                    <option value="">--</option>
                    {niveles.map((nivel) => (
                        <option key={nivel} value={nivel}>
                            {nivel}
                        </option>
                    ))}
                </select>
            </div>
            {/* nombre */}
            <div className='fila-puntaje'>
                <label for="nombre">
                    Nombre:
                </label>
                <select id="nombre" value={nombre} onChange={(e) => setNombre(e.target.value)}>
                    <option value="">--</option>
                    {nombres.map((name) => (
                        <option key={name} value={name}>
                            {name}
                        </option>
                    ))}
                </select>
            </div>
             {/* puntaje TODO: depending on scoreType*/}
             {/* puntaje FIG*/}
             {scoreType === "FIG" && (
                <div className='fila-puntaje'>
                    <label htmlFor="dificultad">
                        Dificultad:
                    </label>
                    <input 
                        id="dificultad" 
                        value={dificultad} 
                        onChange={(e) => {
                            const value = e.target.value;
                            setDificultad(value === '' ? '' : value);
                        }}
                    />
                </div>
            )}

            {/* puntaje USAG*/} 
                {[...Array(parseFloat(numberJudges))].map((_, index) => (
                   
                    <div key={index} className="fila-puntaje">
                        <label htmlFor={`puntaje-${index + 1}`}>
                            Ejecución Juez {index + 1}:
                        </label>
                        <input 
                            id={`puntaje-${index + 1}`} 
                            value={puntajes[index] || ''} 
                            onChange={(e) => {
                                const updatedPuntajes = [...puntajes];
                                updatedPuntajes[index] = e.target.value;
                                setPuntajes(updatedPuntajes);
                            }}
                        />
                    </div>
                ))}

            {/* boton */}
            <button className='boton-mandar' type="submit">
                Mandar
            </button>
            {success && (
                <p className="mensaje-exito">{success}</p>
            )}

            {error && (
                <p className="mensaje-error">{error}</p>
            )}
            </form>
        </div>
    );
};

export default AgregarPuntaje;
